var Flickity = require('flickity');
var imagesLoaded = require('flickity-imagesloaded');

var slideshows = document.querySelectorAll('.fundraiser__slideshow');

for (var i = 0; i < slideshows.length; i += 1) {
  var flkty = new Flickity(slideshows[i], {
    autoPlay: 3000,
    draggable: false,
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false
  });
}
